module.exports = __webpack_public_path__ + "static/img/order-dfh.cd6d9f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order-dfh.png
// module id = 6uCt
// module chunks = 1